var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { attrs: { "data-testid": "signal-strength-indicator" } },
    [
      _vm.presentation
        ? [
            _c(
              "v-icon",
              {
                attrs: {
                  size: _vm.size,
                  "data-testid": "signal-strength-icon",
                },
              },
              [_vm._v(_vm._s(_vm.presentation.icon))]
            ),
            _vm._v("\n    " + _vm._s(_vm.$t(_vm.presentation.labelKey))),
          ]
        : [_vm._v(_vm._s(_vm.$t("signal_strength.unknown")))],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }